module.exports = __webpack_public_path__ + "officialStatic/img/case49.b2e71ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case49.jpg
// module id = nltB
// module chunks = 0